<template>
  <div class="main">
    <!-- loading -->
    <div
      class="loadings"
      v-if="loading"
      v-loading="loading"
      :element-loading-text="loadingtext"
    ></div>
    <heads></heads>
    <banners></banners>
    <!-- <islogin /> -->
    <div class="content">
      <div class="cons">
        <!-- 生成标题0001 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">生成文本</div>
            <el-form-item label="关键词">
              <el-input v-model="form.bt" placeholder="请输入标题或者关键词" />
            </el-form-item>
            <el-form-item label="作者身份">
              <el-input v-model="form2.zz" placeholder="请输入作者" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit11()"
                >生成文本</el-button
              >
            </div>
            <el-form-item label="生成的文本">
              <el-input
                autosize
                type="textarea"
                v-model="form.writerorg2"
                placeholder="请输入文本"
              />
            </el-form-item>
            <div class="custom-block">生成标题</div>
            <el-form-item label="hs">
              <el-input
                autosize
                type="textarea"
                v-model="form.writerorg"
                placeholder="请输入文本"
              />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit12()"
                >生成标题</el-button
              >
            </div>
            <el-form-item label="备选标题">
              <el-input autosize type="textarea" v-model="form.resobj" />
            </el-form-item>
            <el-form-item label="选定标题">
              <el-input v-model="form2.bt" placeholder="请输入标题" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit121()"
                >生成参考文献</el-button
              >
            </div>
            <div class="custom-block">
              <div>参考文献</div>
            </div>
            <div v-for="(item, key) in form.ckwx" :key="key">{{ item }}</div>
          </el-form>
        </div>

        <!-- 第二步 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">生成大纲</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form2.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit21()"
                >生成大纲</el-button
              >
            </div>
            <el-form-item label="大纲">
              <el-input
               autosize
                type="textarea"
                v-model="tigang"
                placeholder="请输入文本"
              />
            </el-form-item>
          </el-form>
        </div>
        <!-- 完善大刚 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">完善大纲</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="formdagang.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit31()"
                >完善大纲</el-button
              >
            </div>
            <el-form-item label="大纲">
              <el-input
               autosize
                type="textarea"
                v-model="tigang2"
                placeholder="请输入文本"
              />
            </el-form-item>
          </el-form>
        </div>
        <!-- 生成引言 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">生成引言</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="formyinyan.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit41()"
                >生成引言</el-button
              >
            </div>
            <el-form-item label="引言">
              <el-input
               autosize
                type="textarea"
                v-model="yinyan"
                placeholder="请输入文本"
              />
            </el-form-item>
          </el-form>
        </div>




        <!-- 第一部分（1500字） -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">第一部分</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form01.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit001()"
                >生成第一部分</el-button
              >
            </div>
            <el-form-item label="第一部分">
              <el-input autosize type="textarea" v-model="reswenti1" />
            </el-form-item>
          </el-form>
        </div>
        <!-- 第二部分（2500字） -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">第二部分</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form02.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit002()"
                >生成第二部分</el-button
              >
            </div>
            <el-form-item label="第二部分">
              <el-input autosize type="textarea" v-model="reswenti2" />
            </el-form-item>
          </el-form>
        </div>
        <!-- 第三部分（2500字） -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">第三部分</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form03.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit003()"
                >第三部分</el-button
              >
            </div>
            <el-form-item label="第三部分">
              <el-input autosize type="textarea" v-model="reswenti3" />
            </el-form-item>
          </el-form>
        </div>


        <!-- 摘要关键词（400字）-->
        <div class="cons-form">
          <el-form :model="form" label-width="120px">
            <div class="custom-block">摘要关键词</div>
            <el-form-item label="hs">
              <el-input autosize type="textarea" v-model="form08.writerorg" />
            </el-form-item>
            <div class="con-btn">
              <el-button type="primary" @click="onSubmit008()">生成摘要关键词</el-button>
            </div>
            <el-form-item label="摘要关键词">
              <el-input autosize type="textarea" v-model="reswenti8" />
            </el-form-item>
          </el-form>
        </div>

        <!-- 论文 -->
        <div class="cons-form">
          <el-form label-width="120px">
            <div class="custom-block">论文全文</div>
            <el-form-item label="全文">
              <el-input autosize type="textarea" v-model="reslunwen" />
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script setup>
import { post } from "@/utils/index";
import { ElMessage } from "element-plus";
import { reactive, ref, inject, getCurrentInstance } from "vue";
import "echarts-wordcloud";
import { useRouter } from "vue-router";

const router = useRouter();
const { proxy } = getCurrentInstance();

const baseurls = "http://server-1:8055";
let loadingtext = ref("系统分析中，请等待...");
// 提纲
let tigang = ref("");
// 完善大纲
let tigang2 = ref("");
// 引言
let yinyan = ref("");
let cankaowenxian = ref("参考文献：\n");
// 每个问题的结果
let reswenti1 = ref("");
let reswenti2 = ref("");
let reswenti3 = ref("");

let reswenti8 = ref("");
// 全文
let reslunwen = ref("");
// loading
let loading = ref(false);
let resobj = ref("");
let form = reactive({
  bt: "",
  ckwx: [],
  writerorg: `学术论文“论文标题“选择要求有一定的“创新性“、”实用性“和”科学性“等要求。假如你是一名顶级学者，请围绕 “@标题@”的中心内容意思，生成10篇题目供参考，每个论文标题只写一句话。中间不能出现符号，又如“ XXX”，输出格式为：
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX；
XXX．
请注意用Markdown格式输出, 以下是关键词：`,
  writerorg2: "",
  resobj: "",
});
let form2 = reactive({
  bt: "",
  zz: "顶级学者",
  writerorg: `假如你是一名@身份@，请围绕 “@标题@”的中心内容意思，
生成一篇临床医学学术论文大纲提纲，涉及年月、病例数、年龄或者其他实验数据的，需要模拟数据。
注意：要输出数据，而不是以“空白”或者“XXX”输出。比如起始时间要具体到年月，具体年龄要数值表示，具体病例数也要数值表示，类似这种有数值型的都要有数据，并且可以计划，前后保持一致。
注意：用阿拉伯数字编号，并用MARKDOWN格式输出。
请根据以下关键词并进行组合。
提纲格式如下：
0 引言
1 资料与方法（或材料与方法）
1.1 一般资料
（如研究对象、实验动物；病例或一般资料等）
1.2 方法
（如实验对象或病例分组等，如还有分层，可再细分）
  1.2.1 XXX
  1.2.2XXX 
  1.2.3 XXX 
1.3 第二层标题
（如实验方法、临床治疗或干预方法等）
1.4 第二层标题 
（如观察指标等）交待观察的指标与观察方法，并分清主要指标与次要指标。
1.5 第二层标题
（如统计学处理）一般应交待统计学分析方法，除非是纯粹的形态学或方法学研究。
2  结果
    结果的叙述应实事求是，简洁明了，数据准确，层次清楚，逻辑严谨，不应与讨论内容相混淆。应着重总结重要的研究结果。以数据反映结果时，不能只描述导数（例如百分数），应同时给出据以计算导数的绝对数。
  2.1 结果的第1项内容
  XXX
  2.2 结果的第1项内容
  XXX
  2.3 结果的第1项内容
  XXX
3 讨论
  3.1 文献表明(结合文献，分别写出4点前人研究的情况：
  3.2 本研究发现(结合本次研究，与文献研究的结果进行比较，得出一个与文献研究一致的结果），XXX及从中得出的结论。本研究结果为：XXX与研究结果一致）。
  3.3 本研究认为(结合本次，分别写出3点研究的结论）。
  3.4 本研究结果与已有文献进行对比和分析，我们进一步发现并得出以下新的有价值的3点结论：
总之，XXX（此部分围绕全文的内容进行总结性阐述）。`,
  writerorg2: "",
});

let formdagang = reactive({
  writerorg: `请统筹完善下面的提纲中的相关数据，可以模拟“数据”或者“数值”。
大纲如下：`,
});
let formyinyan = reactive({
  writerorg: `请根据下面提交的大纲的中“0 引言“的内容扩写一篇临床医学论文的相应部分，不要展开其他部分内容。
提醒注意：
正文中首次出现的缩写必须采用“中文全称（英文全称，缩写）”的形式。
这是一篇临床医学论文。只输出大纲的中或者“0 引言“部分的相关内容，并扩写到相应的字数。
输出内容主要包括：研究背景500字。研究目的400字。研究思路300字。概念理论依据600字。研究起始时间。
注意：要输出数据，而不是以“空白”或者“XXX”输出。比如起码时间要具体到年月。
输出格式如下：
0 引言
大纲如下：`,
});


let form01 = reactive({
  writerorg: `请根据下面提交的大纲的中“1.X“的内容扩写一篇临床医学论文的相应部分，不要展开其他部分内容。
提醒注意：
正文中首次出现的缩写必须采用“中文全称（英文全称，缩写）”的形式。
这是一篇临床医学论文，输出的表格中的数据。相关数据，可以模拟“数据”或者“数值”。
只输出大纲的中或者“1.X“部分的相关内容，并扩写到后面要求的相应字数。
注意：要输出数据，而不是以“空白”或者“XXX”输出。
输出格式如下：
1 资料与方法（或材料与方法）
1.1第二层标题（如对象、实验动物；病例或一般资料等，此部分600汉字以上）
实验研究应交待实验动物、主要仪器与主要试剂的来源、批号、质量标准等；一般仪器与试剂可不必细列。一般情况下，药品使用化学名，不用商品名, 以药典委员会编的《中国药品通用名称》或我国药典中的通用名为准。
临床研究需交待病例和对照者来源、选择标准及研究对象的年龄、性别和其他重要特征等，并应注明参与研究者是否知情同意。临床随机对照研究应交待干预方法的设计（随机方法）和所采用的盲法。
1.2第二层标题（如实验对象或病例分组等，如还有分层，可再细分）
1.2.1 第三层标题  （医学名词以全国自然科学名词审定委员会公布的各学科规范名词为准，药物名称采用通用名而不用商品名。此部分400汉字以上）
…….
1.3 第二层标题（如实验方法、临床治疗或干预方法等，此部分600汉字以上）
涉及到的量的单位请使用《中华人民共和国法定计量单位》中规定的单位。
1.4 第二层标题（如观察指标等，此部分600汉字以上）
交待观察的指标与观察方法，并分清主要指标与次要指标。说明观察方法时应交待重复次数及保证数据质量的相关措施。
1.5 第二层标题（如统计学处理，此部分400汉字以上）
一般应交待统计学分析方法，除非是纯粹的形态学或方法学研究。统计学方法应交待使用的统计软件，对各个主要指标的描述方法、统计检验方法，设定的检验水准等。
大纲如下：`,
});
let form02 = reactive({
  writerorg: `请根据下面提交的大纲的中“2.X“的内容扩写一篇临床医学论文的相应部分，不要展开其他部分内容。
提醒注意：
正文中首次出现的缩写必须采用“中文全称（英文全称，缩写）”的形式。
这是一篇临床医学论文，输出表格中的需要数据。相关数据，可以模拟“数据”或者“数值”。数据要全文统筹并验算相互关系，能参与运算。
只输出大纲的中或者“2.X“部分的相关内容，并扩写到后面要求的相应字数。
再次重要提醒：结果部分，有数据的一定要用“三线表”分别输出，并有具体的模拟数据用于统计分析。三线表输出中，每一项都需要有模拟的数据，并与文本数据保持一致。
本部分总计输出字数不得少于2500字。结果部分需要输出 2.1，2.2，2.3 三项，不能缺项。
注意：要输出数据，而不是以“空白”或者“XXX”输出。
输出示例出下：
2  结果
2.1 结果的第1项内容
结果的叙述应实事求是，简洁明了，数据准确，层次清楚，逻辑严谨，不应与讨论内容相混淆。应着重总结重要的研究结果。以数据反映结果时，不能只描述导数（例如百分数），应同时给出据以计算导数的绝对数。一般应对所得数据进行统计学处理，并给出具体的统计值。例如：F= 3.868，P=0.026。本刊对统计意义的表述使用“差异无统计学意义，P ＞0.05” 、“差异有统计学意义，P ＜0.05”等。 
结果数据较多时，分别使用表格形式展示，并辅以简单的文字说明。
表格格式如：
    表1 不同预后组血清NSE比较（ ）
Tab 1.  Equivalent translation of Chinese table title
GOS评分	例数	血清NSE(ng/ml)
		病程24h	病程3d	病程7d	病程14d
预后不良	9	56.69±4.16	104.94±5.72	103.53±6.09	84.16±3.97
预后良好	31	36.77±11.97	65.70±28.50	57.47±28.84	39.18±19.26
                                                     
  2.2 结果的第2项内容
  示例如2.1
  2.3 结果的第3项内容
  示例如2.1
大纲如下：`,
});
let form03 = reactive({
  writerorg: `请根据下面提交的大纲的中“3.X“的内容扩写一篇临床医学论文的相应部分，不要展开其他部分内容。
提醒注意：
正文中首次出现的缩写必须采用“中文全称（英文全称，缩写）”的形式。
这是一篇临床医学论文，输出表格中的需要数据。相关数据，可以模拟“数据”或者“数值”。数据要全文统筹并验算相互关系，能参与运算。。
只输出大纲的中或者“3.X“部分的相关内容，并扩写到后面要求的相应字数。
结果部分需要输出 3.1，3.2，3.3 ，3.4四项，不能缺项。
注意：要输出数据，而不是以“空白”或者“XXX”输出。
输出示例出下：
3 讨论
3.1 文献回顾（四项内容回顾不能缺失）
（已有研究表明1XXX，这可能与XXX有关。此部分300汉字以上）
（已有研究表明2XXX，这可能与XXX有关。此部分300汉字以上）
（已有研究表明3XXX，这可能与XXX有关。此部分300汉字以上）
（已有研究表明4XXX，这可能与XXX有关。此部分300汉字以上）
3.2 研究发现
XXX及从中得出的结论（此部分300汉字以上）；
本研究结果为：XXX（此部分300汉字以上）。
3.3 研究意义（三项研究认为不能缺失）
（认为1XXX，此部分300汉字以上）。
（认为2XXX，此部分300汉字以上）。
（认为3XXX。此部分300汉字以上）。
3.4 未来研究方向
本研究结果与已有文献进行对比和分析，我们进一步发现并得出以下新的有价值的3点结论（三点结论不能缺失）：
（新结论1： XXX；此部分200汉字以上）。
（新结论2： XXX；此部分200汉字以上）。
（新结论3： XXX；此部分200汉字以上）。
综上所述（这一部分要扩写到1000字以上，围绕“本研究仍存在一定局限性，如样本量较小、药物种类单一等。未来研究可进一步扩大样本量，纳入更多类型的药物，以更全面地评估月经周期对药物浓度及检验结果的影响”展开扩写400字。并分围绕全文的内容进行总结性阐述，600汉字以上）。
大纲如下：`,
});

let form08 = reactive({
  writerorg: `根据下面提供的文章内容，写一段临床医学论文摘要，四百字，并列出五个关键词。
注意：要输出数据，而不是以“空白”或者“XXX”输出。
输出格式为：
 [摘要] 目的：为了……，探讨……（不要说“通过……方法”，此为方法的内容）。方法：本处摘取材料与方法部分的主要内容，如样本数、分组方法、实验方法、观察方法与指标、主要统计分析方法等。结果：摘取结果的主要内容（含主要数据），各主要指标皆应有所描述，附具体的统计量的结果和具体的P值。结论：客观地下结论，可描述应用范围，注意不夸大，不过于肯定。（400字左右）
[关键词] 4~8个，以分号隔开。
内容如下：`,
});

// 生成标题
const onSubmit11 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetSearchZl", {
    bt: form.bt,
    sentence: "",
    subhs: "",
  })
    .then((res) => {
      loading.value = false;
      form.writerorg2 = res.data;
    })
    .catch((err) => {
      loading.value = false;
    });
};
const onSubmit12 = () => {
  loading.value = true;
  // 替换话术
  let temphs = form.writerorg.replace("@标题@", form.bt);
  post(baseurls + "/api/Kw/GetZlCuts", {
    bt: form.bt,
    sentence: form.writerorg2,
    subhs: temphs,
  })
    .then((res) => {
      form.resobj = res.data.resdata;
      // 获取推荐标题
      onSubmit13(res.data.resdata);
    })
    .catch((err) => {
      loading.value = false;
    });
};
const onSubmit13 = (data) => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetTitleTj", {
    sentence: data,
  })
    .then((res) => {
      loading.value = false;
      form2.bt = res.data.bt[0].title;
    })
    .catch((err) => {
      loading.value = false;
    });
};

// 生成参考文献
const onSubmit121=()=>{
  loading.value = true;
  post(baseurls + "/api/Kw/GetCkwxTj", {
    sentence: form2.bt,
  })
    .then((res) => {
      loading.value = false;
      form.ckwx = res.data.list;
      form.ckwx.forEach((e) => {
        cankaowenxian.value += `${e}\n`;
      });
    })
    .catch((err) => {
      loading.value = false;
    });
}

// 生成大纲
const onSubmit21 = () => {
  loading.value = true;
  // 替换话术
  let temphs = form2.writerorg.replace("@标题@", form2.bt);
  form2.writerorg2 = temphs.replace("@身份@", form2.zz);

  post(baseurls + "/api/Kw/GetDgChatAPI", {
    sentence: form2.writerorg2,
  })
    .then((res) => {
      loading.value = false;
      tigang.value = res.data.yw;
      formdagang.writerorg+=tigang.value
    })
    .catch((err) => {
      loading.value = false;
    });
};
// 完善大刚
const onSubmit31=()=>{
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: formdagang.writerorg,
  })
    .then((res) => {
      loading.value = false;
      tigang2.value = res.data;
      formyinyan.writerorg+=res.data
      form01.writerorg+=res.data
    })
    .catch((err) => {
      loading.value = false;
    });
}
// 生成引言
const onSubmit41=()=>{
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: formyinyan.writerorg,
  })
    .then((res) => {
      loading.value = false;
      yinyan.value = res.data
    })
    .catch((err) => {
      loading.value = false;
    });
}

// 生成第一部分
const onSubmit001 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form01.writerorg,
  })
    .then((res) => {
      loading.value = false;
      reswenti1.value = res.data;
      form02.writerorg += tigang2.value;
    })
    .catch((err) => {
      loading.value = false;
    });
};
// 生成第二部分
const onSubmit002 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form02.writerorg,
  })
    .then((res) => {
      loading.value = false;
      reswenti2.value = res.data;
      form03.writerorg += tigang2.value;
    })
    .catch((err) => {
      loading.value = false;
    });
};
// 生成第三部分
const onSubmit003 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form03.writerorg,
  })
    .then((res) => {
      loading.value = false;
      reswenti3.value = res.data;
      form08.writerorg += yinyan.value +  reswenti1.value + reswenti2.value + reswenti3.value + cankaowenxian.value
    })
    .catch((err) => {
      loading.value = false;
    });
};

// 生成摘要关键词
const onSubmit008 = () => {
  loading.value = true;
  post(baseurls + "/api/Kw/GetChatAPI", {
    sentence: form08.writerorg,
  })
    .then((res) => {
      loading.value = false;
      reswenti8.value = res.data;

      //生成全文  标题  摘要关键字  引言   正文   参考文献
      reslunwen.value = `
        ${form2.bt}\n
        ${reswenti8.value}\n
        ${yinyan.value}\n
        ${reswenti1.value}\n
        ${reswenti2.value}\n
        ${reswenti3.value}\n
        ${cankaowenxian.value}
      `;
    })
    .catch((err) => {
      loading.value = false;
    });
};


</script>

<style scoped>
:deep(.el-form-item__label) {
  background: #f5f7fa;
  height: 42px;
  line-height: 42px;
  font-size: 18px;
}
:deep(.cons-form .el-input__inner) {
  height: 40px;
  font-size: 18px;
}
:deep(.cons-form .el-textarea__inner) {
  min-height: 100px !important;
  font-size: 18px;
}
:deep(.cons-form .el-button) {
  width: auto;
  height: 50px;
  font-size: 18px;
}
.main {
  background: #fff;
}
.content {
  width: 1200px;
  height: auto;
  margin: auto;
}
.cons {
  width: 1200px;
  margin: auto;
  padding: 30px 0;
}
.cons-form {
  width: 100%;
}
.cons-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  padding: 0 0 10px 0;
}
.cons-subtitle {
  width: 100%;
  padding: 10px 30px;
  box-sizing: border-box;
  background: #f5f7fa;
  font-size: 14px;
  line-height: 20px;
  color: #999;
  margin: auto;
  margin-bottom: 30px;
}
.custom-block {
  padding: 10px 16px;
  background-color: #ecf5ff;
  border-radius: 4px;
  border-left: 5px solid #409eff;
  margin: 20px 0 20px 0;
  font-size: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.con-btn {
  text-align: center;
  margin-bottom: 30px;
}
.cons-title-subtitle {
  color: #999;
  font-size: 14px;
}
.cons-title-subtitle p {
  margin: 0;
  padding: 0;
  text-align: center;
}
.qksx-list-con {
  font-size: 14px;
  padding: 20px 0 0 0;
}
.qksx-list-con:after {
  content: "";
  display: table;
  clear: both;
}
.xsqk-con {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.xsqk-list {
  cursor: pointer;
}
.xsqk-list-title {
  width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 12px;
}
.xsfx,
#echartsyyy {
  width: 1200px;
  height: 600px;
}
.loadings {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  width: 100%;
  height: 100%;
}
</style>
